import Link from './Link'
import LinkBack from './LinkBack'

Link.Back = LinkBack

export default Link
